import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import './header.css';

import logoHomepage from '../../../assets/img/logo-homepage.png';
import instaIcon from '../../../assets/icon/instagram-ico.svg';
import linkedinIcon from '../../../assets/icon/linkedin-ico.svg';
import NavMenu from '../Navigation/navMenu';
import { useIsMobile } from '../../../lib/Utilis';

function Header() {
    const isMobile = useIsMobile();
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const mobileMenuPanelRef = useRef(null);
    const mobileMenuButtonRef = useRef(null);

    useEffect(() => {
        if (!isMobile) {
            setIsMobileMenuOpen(false);
        }
    }, [isMobile]);

    useEffect(() => {
        document.body.style.overflow = isMobile && isMobileMenuOpen ? 'hidden' : '';
        return () => {
            document.body.style.overflow = '';
        };
    }, [isMobile, isMobileMenuOpen]);

    useEffect(() => {
        if (!isMobileMenuOpen) {
            mobileMenuButtonRef.current?.focus();
            return undefined;
        }

        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                setIsMobileMenuOpen(false);
            }
        };

        document.addEventListener('keydown', handleKeyDown);

        const firstFocusable = mobileMenuPanelRef.current?.querySelector('a, button');
        firstFocusable?.focus();

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [isMobileMenuOpen]);

    return (
        <>
            <header className="header">
                <div className="header-row">
                    <Link to="/" className="header-title-link">
                        <img src={logoHomepage} alt="Logo Delisle Couture" className="header-logo" loading="lazy" />
                    </Link>

                    <nav className="header-nav-list" aria-label="Navigation principale">
                        <Link to="/creations" className="header-nav-link">Créations</Link>
                        <Link to="/lookbooks" className="header-nav-link">Lookbooks</Link>
                        <Link to="/blog" className="header-nav-link">Blog</Link>
                        <Link to="/about" className="header-nav-link">À propos</Link>
                        <Link to="/contact" className="header-nav-link">Contact</Link>
                    </nav>

                    <div className="header-actions">
                        <div className="header-socials" aria-label="Réseaux sociaux">
                            <a
                                href="https://www.instagram.com/delislecouture"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="header-social-link"
                                aria-label="Instagram"
                            >
                                <img src={instaIcon} alt="Instagram" className="header-social-icon" loading="lazy" />
                            </a>
                            <a
                                href="https://www.linkedin.com/in/jerem-delisle"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="header-social-link"
                                aria-label="LinkedIn"
                            >
                                <img src={linkedinIcon} alt="LinkedIn" className="header-social-icon" loading="lazy" />
                            </a>
                        </div>

                        <button
                            ref={mobileMenuButtonRef}
                            type="button"
                            className="header-mobile-toggle"
                            aria-controls="mobile-navigation-panel"
                            aria-expanded={isMobileMenuOpen}
                            aria-label={isMobileMenuOpen ? 'Fermer le menu' : 'Ouvrir le menu'}
                            onClick={() => setIsMobileMenuOpen(prev => !prev)}
                        >
                            {isMobileMenuOpen ? <X size={22} /> : <Menu size={22} />}
                        </button>
                    </div>
                </div>
            </header>

            <div
                className={`nav-sidebar ${isMobileMenuOpen ? 'open' : ''}`}
                onClick={() => setIsMobileMenuOpen(false)}
            >
                <div
                    id="mobile-navigation-panel"
                    ref={mobileMenuPanelRef}
                    className="nav-sidebar-content"
                    onClick={e => e.stopPropagation()}
                >
                    <NavMenu onNavigate={() => setIsMobileMenuOpen(false)} />
                </div>
            </div>
        </>
    );
}

export default Header;
